<script>
let className = '';

export { className as class };
export let required = false;
export let options;
export let option = null;
export let title;
export let name;

let selectedOption = option || options[0];
</script>

<div class={"form-select " + className}>
    <div class="form-title">{title}{required ? "*" : ""}</div>
    <select {name} value={selectedOption} {required}>
        {#each options as option}
            <option value={option.value}>{option.title}</option>
        {/each}
    </select>
</div>

<style global lang="scss">
.form-select {
    @apply mb-8;

    &:not(:first-child) {
        @apply md:ml-5;
    }

    select {
        @apply w-full h-11 bg-transparent border-b text-lg border-white border-opacity-50 focus:border-primary transition outline-none;

        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 0 center;
        background-size: 16px 12px;

        option {
            color: initial;
        }
    }
}
</style>